





















































import useEngageForm from "../useEngageForm";
import processIndicator from "./components/processIndicator.vue";
import newEngageMessageStepsContainer from "./steps/newEngageMessageStepsContainer.vue";
import processNavigationButton from "./components/processNavigationButton.vue";

export default {
    components: {
        processIndicator,
        newEngageMessageStepsContainer,
        processNavigationButton,
    },
    setup(_, { root }) {
        const bvModal = root.$bvModal;
        const {
            form,
            currentStep,
            isSending,
            goToStep,
            nextStep,
            previousStep,
            load,
            selectTemplate,
            editTemplate,
            selectChannel,
            selectName,
        } = useEngageForm(bvModal);
        load();

        const onStepChosen = (stepId: number) => {
            if (goToStep(stepId)) {
                // here you can set action after goToStep succeded
            }
        };
        const onNextStepClicked = async () => {
            if (await nextStep()) {
                // here you can set action after nextStep succeded
            }
        };
        const onPreviousStepClicked = () => {
            if (previousStep()) {
                // here you can set action after previousStep succeded
            }
        };

        return {
            form,
            currentStep,
            //methods
            onStepChosen,
            onNextStepClicked,
            onPreviousStepClicked,
            goToStep,
            selectTemplate,
            editTemplate,
            selectChannel,
            isSending,
            selectName,
        };
    },
};
